
<!------------------------- header start ------------------------------>
<header>
  <!-- navbar start -->
  <nav class="navbar navbar-expand-lg">
    <div class="container-fluid">
      <a class="navbar-brand ms-5" routerLink="/home"><img src="/assets/Expert-ans/image/logo.svg" alt="Logo" /></a>
      <button class="navbar-toggler navbar-light" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav mx-lg-auto mb-2 mb-lg-0">
          <li class="nav-item">
            <a class="nav-link active" aria-current="page"  routerLink="/coverage">Coverage</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" routerLink="/learningCenter">Learning Center</a>
          </li>
          <li class="nav-item">
            <a class="nav-link"  routerLink="/about">About </a>
          </li>

        </ul>
      </div>

      <ul class="navbar-nav last-navbar ms-lg-auto ms-0 mb-2 mb-lg-0">
        <li class="nav-item">
          <a class="nav-link btn-orange" href="#">Get a quota</a>
        </li>
        <li class="nav-item user">
          <a class="nav-link" href="#"> <i class="far fa-user"></i> </a>
        </li>
      </ul>
    </div>
  </nav>

  <!-- hero area start -->
  <section class="hero-area">
    <div class="hero-body">
      <p class="hero-paragraph">Ask The Expert</p>
      <h2 class="h1 hero-header">What Are The Projected Rates of Insurance for 2021?</h2>

      <div class="hero-owner">
        <img src="/assets/Expert-ans/image/Ellipse2.png" class="my-3" alt="Photo" />
        <p><b>Manny Rios</b></p>
        <p>Chief Underwiriting Officer</p>
      </div>
    </div>
  </section>
  <!-- hero area end -->
</header>
<!------------------------- header end ------------------------------>
<!------------------------- post start ------------------------------>
<section class="post">
  <div class="container">
    <div class="row">
      <div class="col-md-3 post-left">
        <div class="share text-center">
          <p class="pr-3">Share</p>
          <p><i class="fab fa-linkedin-in"></i></p>
          <p><i class="fab fa-facebook-f"></i></p>
          <p><i class="fab fa-twitter"></i></p>
        </div>
      </div>
      <div class="col-md-7">
        <div class="post-body">
          <p>
            Becoming a member of the Homeowners Association (HOA) board is about more than just making sure people keep the grass cut and don’t paint their homes the wrong color. Your actions help keep the community running smoothly and safely, and protect the property values of fellow homeowners – and one of the most essential elements of that protection is having the right kind of HOA insurance.
          </p>
          <p>
            It’s not just about having “enough” insurance, but also about having the right kinds of coverage, limits and endorsements. If the board misses a fine-print element, the HOA could be exposed
          </p>
          <h3>The Master Policy</h3>
          <p>
            Directors and officers coverage is a separate form of liability insurance. This comes into play in the event of a lawsuit for negligence (such as failing to have common areas maintained) or malfeasance (such as mishandling funds).
          </p>
          <p>
            If your HOA doesn’t have this kind of insurance, talk to the board about getting it. Even if a lawsuit is dismissed, the HOA must pay to answer and defend itself. And if the HOA is found liable, or even if the lawsuit is settled out of court, the cost to the community could be high.
          </p>
          <ul>
            <li>Showcase and embed your work with</li>
            <li>Publish across social channels in a click</li>
            <li>Sell your videos worldwide</li>
            <li>Embed your work with</li>
          </ul>
        </div>
      </div>
    </div>


    <div class="share-bottom">
      <div class="share text-left">
        <p class="pl-1">Share</p>
        <i class="fab fa-linkedin-in"></i>
        <i class="fab fa-facebook-f"></i>
        <i class="fab fa-twitter"></i>
      </div>
    </div>

    <div class="center">
      <hr>
      <div class="row">
        <div class="col-10 mx-auto">
          <a href="#"><h4><i class="fas fa-long-arrow-alt-left mr-2 mt-4"></i> Ask The Expert</h4></a>
        </div>
      </div>
    </div>




  </div>
</section>
<!------------------------- post end ------------------------------>















<!-----------------------  coverage start ----------------------->
<section class="coverage">
  <div class="container">
    <div class="coverage-body">
      <div class="row">
        <div class="col-md-6">
          <h3>Better coverage is closer than you think</h3>
        </div>
        <div class="col-md-6 px-5 pt-4">
          <p class="coverage-text coverage-text1">Tell us about your property</p>
          <p class="coverage-text coverage-text2">Get an instant, personalized quote</p>
          <p class="coverage-text coverage-text3">Enjoy up to 50% savings</p>
        </div>
        <div class="col-md-6">
          <p class="text-center mt-md-0 mt-5"><a href="#" class="btn-orange d-block w-50 mx-auto">Get Start</a></p>
        </div>
      </div>
    </div>
  </div>
</section>
<!-----------------------  social start ----------------------->
<div class="social py-5">
  <div class="container-fluid">
    <img src="/assets/image/Vector.svg" class="d-lg-block d-none mx-auto" alt="Logo" />
    <img src="/assets/Coverage/image/logo.svg" class="d-lg-none d-block mx-auto" alt="Logo">
  </div>
  <p class="social-links text-center d-lg-none d-block mt-4">
    <a href="#"><i class="fab fa-facebook-square"></i></a>
    <a href="#"><i class="fab fa-twitter"></i></a>
    <a href="#"><i class="fab fa-linkedin"></i></a>
  </p>
  <nav>
    <div class="container-fluid my-5">
      <p class="text-center">
        <a routerLink="/coverage">Coverage</a>
        <a routerLink="/learningCenter">Learning Center</a>
        <a routerLink="/expertAsk">Ask The Expert</a>
        <a routerLink="/about">About</a>
      </p>
    </div>
  </nav>

  <p class="social-links text-center d-lg-block d-none">
    <a href="#"><i class="fab fa-facebook-square"></i></a>
    <a href="#"><i class="fab fa-twitter"></i></a>
    <a href="#"><i class="fab fa-linkedin"></i></a>
  </p>
</div>
<!-----------------------  social end ----------------------->
<!------------------------- footer start ------------------------------>
<footer>
  <div class="container">
    <div class="row">
      <div class="col-lg-6">
        <p class="text-lg-left d-lg-block d-none text-center"> &#169; 2020 Honeycomb Insurance. All rights reserved.</p>
        <p class="text-lg-left d-lg-none d-block text-center"> &#169; © 2020 Acme. All right reserved.</p>
      </div>
      <div class="col-lg-6">
        <p class="text-lg-right text-center">
          <a href="#" class="d-lg-inline d-block">Privacy Policy</a>
          <a href="#" class="d-lg-inline d-block my-4">Terms of Service</a>
        </p>
      </div>
    </div>
  </div>
</footer>
<!------------------------- footer end ------------------------------>
